<template>
  <div v-if="visible" class="custom-time-modal-overlay" @click="handleClose">
    <div class="custom-time-modal" @click.stop>
      <div class="modal-header">
        <div style="font-size: 16px;font-weight: bold;color: #42b983;">选择时间范围</div>
        <button class="close-btn" @click="handleClose">×</button>
      </div>
      <div class="modal-body">
        <div class="date-inputs">
          <div class="date-input-group">
            <label>开始时间：</label>
            <el-date-picker 
              style="width: 100%;" 
              v-model="localTimeRange.startDate" 
              type="date" 
              placeholder="选择开始日期"
              format="yyyy-MM-dd" 
              value-format="yyyy-MM-dd" 
              @change="onTimeChange" 
              align="center">
            </el-date-picker>
          </div>
          <div class="date-input-group">
            <label>结束时间：</label>
            <el-date-picker 
              style="width: 100%;" 
              v-model="localTimeRange.endDate" 
              type="date" 
              placeholder="选择结束日期"
              format="yyyy-MM-dd" 
              value-format="yyyy-MM-dd" 
              @change="onTimeChange" 
              align="center">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button 
          class="btn-confirm" 
          @click="handleConfirm"
          :disabled="!localTimeRange.startDate || !localTimeRange.endDate">
          确定
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomTimePicker',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    timeRange: {
      type: Object,
      default: () => ({
        startDate: '',
        endDate: ''
      })
    }
  },
  data() {
    return {
      localTimeRange: {
        startDate: '',
        endDate: ''
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // 打开时同步外部传入的时间范围
        this.localTimeRange = {
          startDate: this.timeRange.startDate || '',
          endDate: this.timeRange.endDate || ''
        }
      }
    },
    timeRange: {
      handler(newVal) {
        this.localTimeRange = {
          startDate: newVal.startDate || '',
          endDate: newVal.endDate || ''
        }
      },
      deep: true
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    
    onTimeChange() {
      // 验证时间范围
      if (this.localTimeRange.startDate && this.localTimeRange.endDate) {
        if (this.localTimeRange.startDate > this.localTimeRange.endDate) {
          this.$message.warning('开始时间不能晚于结束时间')
          return
        }
      }
    },
    
    handleConfirm() {
      if (!this.localTimeRange.startDate || !this.localTimeRange.endDate) {
        this.$message.warning('请选择开始时间和结束时间')
        return
      }

      if (this.localTimeRange.startDate > this.localTimeRange.endDate) {
        this.$message.warning('开始时间不能晚于结束时间')
        return
      }

      // 发送确认事件，传递格式化的时间范围
      const formattedTimeRange = {
        startTime: this.localTimeRange.startDate + ' 00:00:00',
        endTime: this.localTimeRange.endDate + ' 23:59:59',
        startDate: this.localTimeRange.startDate,
        endDate: this.localTimeRange.endDate
      }
      
      this.$emit('confirm', formattedTimeRange)
    }
  }
}
</script>

<style scoped lang="scss">
/* 自定义时间选择弹窗样式 */
.custom-time-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.custom-time-modal {
  background: white;
  width: 100%;
  max-width: 500px;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 10px;
  border-bottom: 1px solid #f0f0f0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #666;
}

.modal-body {
  padding: 20px;
}

.date-inputs {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 10px 0;
}

.date-input-group {
  display: flex;
  gap: 8px;
}

.date-input-group label {
  width: 90px;
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.modal-footer {
  display: flex;
  padding: 20px;
  border-top: 1px solid #f0f0f0;
  justify-content: space-between;
}

.btn-confirm {
  flex: 1;
  background: #42b983;
  color: white;
  border: 1px solid #42b983;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s ease;
}

.btn-confirm:hover:not(:disabled) {
  background: #369870;
  border-color: #369870;
}

.btn-confirm:disabled {
  background: #ccc;
  border-color: #ccc;
  cursor: not-allowed;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .custom-time-modal {
    max-width: 100%;
    border-radius: 12px 12px 0 0;
  }

  .modal-body {
    padding: 10px;
  }

  .modal-footer {
    padding: 10px;
    gap: 10px;
  }

  .btn-confirm {
    padding: 8px 12px;
    font-size: 14px;
  }
}

::v-deep {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
  .el-input__inner {
    background-color: #f8f9fa !important;
  }
}
</style>
